import { render, staticRenderFns } from "./login-input-password.vue?vue&type=template&id=272b1bf6&scoped=true"
import script from "./login-input-password.vue?vue&type=script&lang=js"
export * from "./login-input-password.vue?vue&type=script&lang=js"
import style0 from "./login-input-password.vue?vue&type=style&index=0&id=272b1bf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272b1bf6",
  null
  
)

export default component.exports